import { Component, OnInit , Input} from '@angular/core';

@Component({
  selector: 'styledchx',
  template: require('./styledchx.component.html'),
  styles: [require('./styledchx.component.scss')]
})
export class StyledchxComponent implements OnInit {

  @Input() public state: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  

}
